export default __webpack_public_path__ + "static/media/isabela.81726926.jpg";